import { render, staticRenderFns } from "./home-skeleton.vue?vue&type=template&id=316dca26&scoped=true"
var script = {}
import style0 from "./home-skeleton.vue?vue&type=style&index=0&id=316dca26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316dca26",
  null
  
)

export default component.exports